import {h, VNode} from 'virtual-dom';

import {languageSpecificSettingOverrides} from './language-specific-setting-override';
import {languageConstants} from './language-constants';

const defaultLanguageCode = languageConstants.languages[languageConstants.default];

export default {
    textConstants: {
        "lessLinkText": languageSpecificSettingOverrides[defaultLanguageCode]["textConstants.lessLinkText"],
        "moreLinkText": languageSpecificSettingOverrides[defaultLanguageCode]["textConstants.moreLinkText"],
        "almeDisplayName": languageSpecificSettingOverrides[defaultLanguageCode]["textConstants.almeDisplayName"],//"IVA: ",
        "bannerText":  languageSpecificSettingOverrides[defaultLanguageCode]["textConstants.bannerText"],
        "inputboxPlaceholderText": languageSpecificSettingOverrides[defaultLanguageCode]["textConstants.inputboxPlaceholderText"],
        "userDisplayName": languageSpecificSettingOverrides[defaultLanguageCode]["textConstants.userDisplayName"],
        "launchPointText": languageSpecificSettingOverrides[defaultLanguageCode]["textConstants.launchPointText"],
        "defaultErrorResponse": languageSpecificSettingOverrides[defaultLanguageCode]["textConstants.errorResponse"],
        "pleaseWaitText": languageSpecificSettingOverrides[defaultLanguageCode]["textConstants.pleaseWaitText"],
        "pendingPlaceholder": languageSpecificSettingOverrides[defaultLanguageCode]["textConstants.pendingPlaceholder"],
        "inputboxDisabledPlaceholderText": languageSpecificSettingOverrides[defaultLanguageCode]["textConstants.pleaseWaitText"],
        "liveChatPendingPlaceholder": languageSpecificSettingOverrides[defaultLanguageCode]["textConstants.pendingPlaceholder"],
        "sendButtonTitleText": languageSpecificSettingOverrides[defaultLanguageCode]["textConstants.sendButtonTitleText"],
        // Disabled for Font Awesome Removal
        // "submitContent": (): VNode => h('div', {className: "fa-solid fa-paper-plane"},[]),
        "submitContent": languageSpecificSettingOverrides[defaultLanguageCode]["textConstants.submitContent"],
        "minimizeWindowTitleText": languageSpecificSettingOverrides[defaultLanguageCode]["textConstants.minimizeWindowTitleText"],
        "linkFoldTitleText": languageSpecificSettingOverrides[defaultLanguageCode]["textConstants.linkFoldTitleText"],
        "viewPageLinkText": languageSpecificSettingOverrides[defaultLanguageCode]["textConstants.viewPageLinkText"],
        "payloadDefaultIvaValue": [
            "default",
            "predeterminado", 
            "par défaut",
            "默认",
            "افتراضي",
        ],
        "displayLinksHeaderText": "",
        "skipToContentLinkText": languageSpecificSettingOverrides[defaultLanguageCode]["textConstants.skipToContentLinkText"],

        // data collection form
        "dataCollectionFormatError": languageSpecificSettingOverrides[defaultLanguageCode]["textConstants.dataCollectionFormatError"],
        "dataCollectionRequiredError": languageSpecificSettingOverrides[defaultLanguageCode]["textConstants.dataCollectionRequiredError"],
        "dataCollectionRequiredTextDesc" : languageSpecificSettingOverrides[defaultLanguageCode]["textConstants.dataCollectionRequiredTextDesc"],
        
        //Timeout Warning Form
        "timeoutWarningNoTitle": languageSpecificSettingOverrides[defaultLanguageCode]["textConstants.timeoutWarningNoTitle"],
        "timeoutWarningText": languageSpecificSettingOverrides[defaultLanguageCode]["textConstants.timeoutWarningText"],
        "timeoutWarningYesTitle": languageSpecificSettingOverrides[defaultLanguageCode]["textConstants.timeoutWarningYesTitle"],
        "inputboxErrorText": languageSpecificSettingOverrides[defaultLanguageCode]["textConstants.inputboxErrorText"],

        "xPosition": languageSpecificSettingOverrides[defaultLanguageCode]["xPosition"],
        "yPosition": languageSpecificSettingOverrides[defaultLanguageCode]["yPosition"],
        "inlineSurveyTitle": languageSpecificSettingOverrides[defaultLanguageCode]["inlineSurveyTitle"],
        "surveyCancelTitle": languageSpecificSettingOverrides[defaultLanguageCode]["surveyCancelTitle"],
        "surveyCloseTitle": languageSpecificSettingOverrides[defaultLanguageCode]["surveyCloseTitle"],
        "surveyFreeformAriaLabel": languageSpecificSettingOverrides[defaultLanguageCode]["surveyFreeformAriaLabel"],
        "surveyFreeformTextTitle": languageSpecificSettingOverrides[defaultLanguageCode]["surveyFreeformTextTitle"],
        "surveyQuestionNoTitle": languageSpecificSettingOverrides[defaultLanguageCode]["surveyQuestionNoTitle"],
        "surveyQuestionYesTitle": languageSpecificSettingOverrides[defaultLanguageCode]["surveyQuestionYesTitle"],
        "surveyRadioButtonsTitle": languageSpecificSettingOverrides[defaultLanguageCode]["surveyRadioButtonsTitle"],
        "surveySubmitTitle": languageSpecificSettingOverrides[defaultLanguageCode]["surveySubmitTitle"],

        "endChatWarningText": languageSpecificSettingOverrides[defaultLanguageCode]["endChatWarningText"],
        "endChatWarningYesTitle": languageSpecificSettingOverrides[defaultLanguageCode]["endChatWarningYesTitle"],
        "endChatWarningNoTitle": languageSpecificSettingOverrides[defaultLanguageCode]["endChatWarningNoTitle"],

        // live chat foundations
        errorResponse : languageSpecificSettingOverrides[defaultLanguageCode]["livechat.textConstants.errorResponse"],
        submitKey: languageSpecificSettingOverrides[defaultLanguageCode]["livechat.textConstants.submitKey"],
    },
};


// WEBPACK FOOTER //
// ./settings/text-constants.ts